import Cookies from 'js-cookie';

const Locale = Cookies.get('userLocale')?.trim() ? Cookies.get('userLocale') : Cookies.get('Locale') || 'India';
// const Locale = Cookies.get('Locale') || 'India';
console.log('locale iss',Locale)
let DateFormat;
let DateTimeFormat;

switch (Locale) {
    
  case "Canada":  
  case 'United States (US)':
    console.log('date format is ',Locale);
    DateFormat = 'MM/DD/YYYY';
    DateTimeFormat = 'MM/DD/YYYY hh:mm A';
    break;
  case 'United Kingdom (UK)':
  case 'India':
    DateFormat = 'DD/MM/YYYY';
    DateTimeFormat = 'DD/MM/YYYY hh:mm A';
    break;
  default:
    DateFormat = 'DD/MM/YYYY';
    DateTimeFormat = 'DD/MM/YYYY hh:mm A';
    break;
}

 //const BASE_URL = 'http://localhost:4000';
const BASE_URL = 'https://apinucleus.mind-mesh.com';
const DiffChecker_URL='https://aiapi.mind-mesh.com';
// const DiffChecker_URL='http://127.0.0.1:8000';

const helpTextFormula = `
Use operators like +, -, *, / for calculations. 
Example: IF(Salary > 50000, "High", "Low"). 
Functions like CONCAT, DATE, and ROUND are also supported.
`;

const currencyMap = [
  { _id: "$", Name: "US Dollar (USD)", code: "USD" },
  { _id: "€", Name: "Euro (EUR)", code: "EUR" },
  { _id: "£", Name: "British Pound (GBP)", code: "GBP" },
  { _id: "₹", Name: "Indian Rupee (INR)", code: "INR" },
  { _id: "¥", Name: "Japanese Yen (JPY)", code: "JPY" },
  { _id: "₩", Name: "South Korean Won (KRW)", code: "KRW" },
  { _id: "C$", Name: "Canadian Dollar (CAD)", code: "CAD" },
  { _id: "A$", Name: "Australian Dollar (AUD)", code: "AUD" },
  { _id: "CHF", Name: "Swiss Franc (CHF)", code: "CHF" },
  { _id: "R$", Name: "Brazilian Real (BRL)", code: "BRL" },
  { _id: "₽", Name: "Russian Ruble (RUB)", code: "RUB" },
  { _id: "₺", Name: "Turkish Lira (TRY)", code: "TRY" },
  { _id: "HK$", Name: "Hong Kong Dollar (HKD)", code: "HKD" },
  { _id: "SGD", Name: "Singapore Dollar (SGD)", code: "SGD" },
  { _id: "NZ$", Name: "New Zealand Dollar (NZD)", code: "NZD" },
  { _id: "MX$", Name: "Mexican Peso (MXN)", code: "MXN" },
  { _id: "AED", Name: "UAE Dirham (AED)", code: "AED" },
  { _id: "ZAR", Name: "South African Rand (ZAR)", code: "ZAR" },
  { _id: "SEK", Name: "Swedish Krona (SEK)", code: "SEK" },
  { _id: "NOK", Name: "Norwegian Krone (NOK)", code: "NOK" },
  { _id: "DKK", Name: "Danish Krone (DKK)", code: "DKK" },
  { _id: "PLN", Name: "Polish Zloty (PLN)", code: "PLN" }
];


const TIMEZONE_MAP = {
  UTC: 'UTC',
  GMT: 'Etc/GMT',
  IST: 'Asia/Kolkata',
  PST: 'America/Los_Angeles',
  PDT: 'America/Los_Angeles',
  MST: 'America/Denver',
  MDT: 'America/Denver',
  CST: 'America/Chicago',
  CDT: 'America/Chicago',
  EST: 'America/New_York',
  EDT: 'America/New_York',
  AKST: 'America/Anchorage',
  HST: 'Pacific/Honolulu',
  AST: 'America/Halifax',
  JST: 'Asia/Tokyo',
  KST: 'Asia/Seoul',
  CST_CHINA: 'Asia/Shanghai', // For China Standard Time
  HKT: 'Asia/Hong_Kong',
  SGT: 'Asia/Singapore',
  CET: 'Europe/Paris',
  CEST: 'Europe/Paris',
  EET: 'Europe/Bucharest',
  EEST: 'Europe/Bucharest',
  AEST: 'Australia/Sydney',
  AEDT: 'Australia/Sydney',
  NZST: 'Pacific/Auckland',
  NZDT: 'Pacific/Auckland',
  ART: 'America/Argentina/Buenos_Aires',
  WAT: 'Africa/Lagos',
  CAT: 'Africa/Harare',
  EAT: 'Africa/Nairobi',
  // Canada specific timezones
  NST_CANADA: 'America/St_Johns',       // Newfoundland Standard Time
  AST_CANADA: 'America/Halifax',        // Atlantic Standard Time (Canada)
  EST_CANADA: 'America/Toronto',        // Eastern Standard Time (Canada)
  CST_CANADA: 'America/Winnipeg',       // Central Standard Time (Canada)
  MST_CANADA: 'America/Edmonton',       // Mountain Standard Time (Canada)
  PST_CANADA: 'America/Vancouver',      // Pacific Standard Time (Canada)
};

const localeMap = {
  India:'India',
  United_States :"United States (US)",
  United_Kingdom:"United Kingdom (UK)",
  Canada: "Canada",
}
 const COUNTRY_OPTIONS_WITHOUT_CURRENCY = [
  { label: 'Afghanistan', value: 'afghanistan' },
  { label: 'Albania', value: 'albania' },
  { label: 'Algeria', value: 'algeria' },
  { label: 'Andorra', value: 'andorra' },
  { label: 'Angola', value: 'angola' },
  { label: 'Argentina', value: 'argentina' },
  { label: 'Armenia', value: 'armenia' },
  { label: 'Australia', value: 'australia' },
  { label: 'Austria', value: 'austria' },
  { label: 'Bangladesh', value: 'bangladesh' },
  { label: 'Belgium', value: 'belgium' },
  { label: 'Bhutan', value: 'bhutan' },
  { label: 'Brazil', value: 'brazil' },
  { label: 'Canada', value: 'canada' },
  { label: 'Chile', value: 'chile' },
  { label: 'China', value: 'china' },
  { label: 'Colombia', value: 'colombia' },
  { label: 'Czech Republic', value: 'czech-republic' },
  { label: 'Denmark', value: 'denmark' },
  { label: 'Egypt', value: 'egypt' },
  { label: 'Estonia', value: 'estonia' },
  { label: 'Finland', value: 'finland' },
  { label: 'France', value: 'france' },
  { label: 'Germany', value: 'germany' },
  { label: 'Ghana', value: 'ghana' },
  { label: 'Greece', value: 'greece' },
  { label: 'Hong Kong', value: 'hong-kong' },
  { label: 'Hungary', value: 'hungary' },
  { label: 'Iceland', value: 'iceland' },
  { label: 'India', value: 'india' },
  { label: 'Indonesia', value: 'indonesia' },
  { label: 'Iran', value: 'iran' },
  { label: 'Iraq', value: 'iraq' },
  { label: 'Ireland', value: 'ireland' },
  { label: 'Israel', value: 'israel' },
  { label: 'Italy', value: 'italy' },
  { label: 'Japan', value: 'japan' },
  { label: 'Jordan', value: 'jordan' },
  { label: 'Kenya', value: 'kenya' },
  { label: 'Kuwait', value: 'kuwait' },
  { label: 'Latvia', value: 'latvia' },
  { label: 'Lebanon', value: 'lebanon' },
  { label: 'Lithuania', value: 'lithuania' },
  { label: 'Luxembourg', value: 'luxembourg' },
  { label: 'Malaysia', value: 'malaysia' },
  { label: 'Mexico', value: 'mexico' },
  { label: 'Morocco', value: 'morocco' },
  { label: 'Nepal', value: 'nepal' },
  { label: 'Netherlands', value: 'netherlands' },
  { label: 'New Zealand', value: 'new-zealand' },
  { label: 'Nigeria', value: 'nigeria' },
  { label: 'Norway', value: 'norway' },
  { label: 'Pakistan', value: 'pakistan' },
  { label: 'Philippines', value: 'philippines' },
  { label: 'Poland', value: 'poland' },
  { label: 'Portugal', value: 'portugal' },
  { label: 'Qatar', value: 'qatar' },
  { label: 'Romania', value: 'romania' },
  { label: 'Russia', value: 'russia' },
  { label: 'Saudi Arabia', value: 'saudi-arabia' },
  { label: 'Serbia', value: 'serbia' },
  { label: 'Singapore', value: 'singapore' },
  { label: 'Slovakia', value: 'slovakia' },
  { label: 'Slovenia', value: 'slovenia' },
  { label: 'South Africa', value: 'south-africa' },
  { label: 'South Korea', value: 'south-korea' },
  { label: 'Spain', value: 'spain' },
  { label: 'Sri Lanka', value: 'sri-lanka' },
  { label: 'Sweden', value: 'sweden' },
  { label: 'Switzerland', value: 'switzerland' },
  { label: 'Taiwan', value: 'taiwan' },
  { label: 'Thailand', value: 'thailand' },
  { label: 'Turkey', value: 'turkey' },
  { label: 'United Arab Emirates', value: 'uae' },
  { label: 'United Kingdom', value: 'uk' },
  { label: 'Ukraine', value: 'ukraine' },
  { label: 'United States', value: 'usa' },
  { label: 'Vietnam', value: 'vietnam' },
  { label: 'Zambia', value: 'zambia' },
  { label: 'Zimbabwe', value: 'zimbabwe' },
  { label: 'Other', value: 'other' },
];

 const COUNTRY_OPTIONS = [
  {
    label: 'India',
    value: 'india',
    currency: {label:"Indian Rupee",name: "INR", symbol:'₹', iso_code: "INR",conversion_rate:"1",active:true,coorporate:true},
    locale: 'India',
    timezone: 'IST',
  },
  {
    label: 'United States',
    value: 'usa',
    currency: {label:"US Dollar",name:"USD", symbol:'$', iso_code: "USD",conversion_rate:"1",active:true,coorporate:true},
    locale: 'United_States',
    timezone: 'UTC',
  },
  {
    label: 'United Kingdom',
    value: 'uk',
    currency: {label:"British Pound",name:"GBP",symbol:'£', iso_code: "GBP",conversion_rate:"1",active:true,coorporate:true},
    locale: 'United_Kingdom',
    timezone: 'UTC',
  },
  {
    label: 'Other',
    value: 'other',
    currency: {label:"US Dollar",name:"USD",symbol: '$',iso_code: 'USD',conversion_rate: '1',active: true,corporate: true},
    locale: 'United_States',
    timezone: 'UTC',
  },
];


const BASE_OPERATORS = {
  equality: [
    { value: "", label: "Equals" },
    { value: "$ne", label: "Not Equals" },
  ],
  comparison: [
    { value: "$gt", label: "Greater Than" },
    { value: "$gte", label: "Greater Than or Equal" },
    { value: "$lt", label: "Less Than" },
    { value: "$lte", label: "Less Than or Equal" },
  ],
  string: [
    { value: "contains", label: "Contains" },
    { value: "starts_with", label: "Starts With" },
    { value: "ends_with", label: "Ends With" },
  ],
  nullChecks: [
    { value: "isnull", label: "Is Null" },
    { value: "not_null", label: "Is Not Null" },
  ],
};


const FIELD_TYPE_RULES = {
  string: ["equality", "string", "nullChecks"],
  textarea: ["equality", "string", "nullChecks"],
  richtext: ["equality", "string", "nullChecks"],

  integer: ["equality", "comparison", "nullChecks"],
  decimal: ["equality", "comparison", "nullChecks"],
  currency: ["equality", "comparison", "nullChecks"],
  percentage: ["equality", "comparison", "nullChecks"],

  boolean: ["equality", "nullChecks"],

  date: ["equality", "comparison", "nullChecks"],
  datetime: ["equality", "comparison", "nullChecks"],

  email: ["equality", "string", "nullChecks"],
  phone: ["equality", "nullChecks"],
  url: ["equality", "string", "nullChecks"],

  picklist: ["equality", "nullChecks"],
  multiselect: ["equality", "string", "nullChecks"],

  lookup: ["equality", "nullChecks"],

  address: ["string", "nullChecks"],

  rollup: ["equality", "comparison", "nullChecks"],
  formula: ["equality", "comparison", "string", "nullChecks"],
};



const SERVER_SCORING_URL = "http://127.0.0.1:8000";

export { BASE_URL,DiffChecker_URL, SERVER_SCORING_URL,DateFormat, helpTextFormula, DateTimeFormat,TIMEZONE_MAP,currencyMap,localeMap,COUNTRY_OPTIONS,BASE_OPERATORS,FIELD_TYPE_RULES  };